module.exports = __webpack_public_path__ + "img/plus-circle.44062e1d.svg";